import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useParams } from "react-router-dom";

import Finish from './Finish';
import { ErrorAlert } from '../../utils/Alerts';
import { unauthHeaders } from '../../utils/API';
import UserContext from '../../UserContext';
import useWindowDimensions from '../Lk/useWindowDimensions';
import FinishMobile from './FinishMobile';

const FinishContainer = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    const { typeServices } = useParams();

    const {
        appointment,
        clinic,
        cabinetName,
        setIsDisabledNextBtn,
        user,
        openLeftMenu
    } = useContext(UserContext);

    const unlockCell = () => {
        axios.get(`${process.env.REACT_APP_API}api/v1.0/schedule/timetable/unlock-cell?scheduleId=${appointment.ScheduleId}&userId=${appointment.PatientInfo.Id}`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                // getAppointments();
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    const createAppointment = () => {
        setIsLoading(true);
        axios.post(`${process.env.REACT_APP_API}api/v1.0/schedule/appointments`, {
            ...appointment
        }, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                unlockCell();
                history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/appointments`)
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsDisabledNextBtn(false);
                setIsLoading(false);
            });
    }

    useEffect(() => {
        setIsDisabledNextBtn(false);
    }, []);

    const complete = () => {
        createAppointment();
        setIsDisabledNextBtn(true);
    }

    const onHandlePrevBtn = () => {
        unlockCell();
        history.goBack();
    }

    if (!appointment || !clinic) {
        history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk`);
    }

    return (
        <>
            {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
            {useWindowDimensions().width > 601
                ? <Finish
                    isLoading={isLoading}
                    appointment={appointment}
                    clinic={clinic}
                    complete={complete}
                    cabinetName={cabinetName}
                    user={user}
                    onHandlePrevBtn={onHandlePrevBtn}
                    openLeftMenu={openLeftMenu}
                    typeServices={typeServices}
                />
                : <FinishMobile
                    isLoading={isLoading}
                    appointment={appointment}
                    clinic={clinic}
                    complete={complete}
                    cabinetName={cabinetName}
                    user={user}
                    onHandlePrevBtn={onHandlePrevBtn}
                    openLeftMenu={openLeftMenu}
                    typeServices={typeServices}
                />}
        </>
    )
}

export default FinishContainer;
